export default __webpack_public_path__ + "static/media/message-square.e7ac7bdf.svg";